module.exports = {
    bindings: { 
        classification: '<', 
        query: '<' 
    },
    templateUrl: 'classification-regulations/components/classification-regulation-old.html',
};